var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-7 py-4",staticStyle:{"background":"#f7f7f7","height":"auto"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/thingsToDo/WTH1.jpg")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }